import Vue from 'vue'
import App from './App.vue'
import router from './config/router.js'
import store from './config/store.js'
import vSelect from "vue-select";
 
//custom select - vue-select
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";

//cookie
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)


//JQUERY globally
window.$ = window.jQuery = require('jquery');

//BOOSTSTRAP
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'


//CUSTOM CSS
import '@/css/main.min.css'

//layouts
import DefaultLayout from '@/layouts/MasterLayout.vue'
import EmptyLayout from '@/layouts/EmptyLayout.vue'


Vue.component('default-layout', DefaultLayout);
Vue.component('empty-layout', EmptyLayout);

Vue.config.productionTip = false

Vue.mixin({

  methods:{
    currentLangName(){           
        if  (this.$store.getters.getSelectedLang.name === null || this.$store.getters.getSelectedLang.name === undefined || this.$store.getters.getSelectedLang.name === ''){
            // console.log('deflang')
            return this.$store.getters.getDefaultLang.name.toLowerCase()
        } else {
            return this.$store.getters.getSelectedLang.name.toLowerCase()
        }      
    },    
    lang(tagname){      
        return this.$store.getters.getLangFile[tagname]        
    },  
    getCategoryData(itemId, categoryArray){
        //get the current information id to related category
        let categoryData = [] // [{name: "", id: ""}] 
        let connectArray = this.$store.getters.getInformationToCategory;                      
                
        try {                                                                    
            connectArray.find( item => {                
                if (parseInt(item.information_id) === parseInt(itemId)) {                    
                    categoryData.push({
                        id: item.category_id,
                        name: null,
                        slug: null,
                        sort_order: null
                    })
                }
            });            

            categoryData.forEach( element => {
                categoryArray.find( item => {                    
                    if (parseInt(item.id) === parseInt(element.id)) {                        
                       element.name = item.name,
                       element.slug = item.slug, 
                       element.sort_order = item.sort_order
                    }
                })
            })

        } catch (error) {
            console.log(error);                            
        }        

        return categoryData
    },
    itemSrcset(item){
        if (item.image){
            return item.image.srcset
        } else {
            return "no-image"
        }
    },
    itemSrc(item, cacheSize){
        if (item.image){            
            let cacheSrcs = Object.entries(item.image.cache)                        

            for (let [srckey, srcvalue] of cacheSrcs) {                                                  
                if (srckey == cacheSize){                                      
                    return srcvalue
                } 
            }
        } else {
            return "no-image"
        }
    },
    hasHttp(link){
        return link.includes("http") ? true : false
    },
    deleteMetaTags(){
        //clear the meta tags
        let metaDesc = document.querySelectorAll('meta[name="description"]')
  
        if (metaDesc.length > 0){                
            let elem = metaDesc[0]            
            elem.parentNode.removeChild(elem)
        }

        let metaKeywords = document.querySelectorAll('meta[name="keywords"]')
  
        if (metaKeywords.length > 0){
            let elem = metaKeywords[0]            
            elem.parentNode.removeChild(elem)
        }

        let metaOgTitle = document.querySelectorAll('meta[property="og:title"]')
  
        if (metaOgTitle.length > 0){
            let elem = metaOgTitle[0]            
            elem.parentNode.removeChild(elem)
        }

        let metaOgType = document.querySelectorAll('meta[property="og:type"]')
  
        if (metaOgType.length > 0){
            let elem = metaOgType[0]            
            elem.parentNode.removeChild(elem)
        }

        let metaOgSiteName = document.querySelectorAll('meta[property="og:site_name"]')
  
        if (metaOgSiteName.length > 0){
            let elem = metaOgSiteName[0]            
            elem.parentNode.removeChild(elem)
        }

        let metaOgUrl = document.querySelectorAll('meta[property="og:url"]')
  
        if (metaOgUrl.length > 0){
            let elem = metaOgUrl[0]            
            elem.parentNode.removeChild(elem)
        }

        let metaogImage = document.querySelectorAll('meta[property="og:image"]')
  
        if (metaogImage.length > 0){
            let elem = metaogImage[0]            
            elem.parentNode.removeChild(elem)
        }

        let metaOgImageWidth = document.querySelectorAll('meta[property="og:image:width"]')
  
        if (metaOgImageWidth.length > 0){
            let elem = metaOgImageWidth[0]            
            elem.parentNode.removeChild(elem)
        }

        let metaOgImageHeight = document.querySelectorAll('meta[property="og:image:height"]')
  
        if (metaOgImageHeight.length > 0){
            let elem = metaOgImageHeight[0]            
            elem.parentNode.removeChild(elem)
        }

        let metaOgDesc = document.querySelectorAll('meta[property="og:description"]')
  
        if (metaOgDesc.length > 0){            
            let elem = metaOgDesc[0]            
            elem.parentNode.removeChild(elem)
        }
    },
    setMetaTags( metaTags){
        //clear the meta tags - need this because duplicate data call - example products category list page
        this.deleteMetaTags()        

        // this.setMetaTags({
        //     title: title, 
        //     desc: desc, 
        //     keywords:keywords, 
        //     ogType:ogType, 
        //     ogTitle:ogTitle,                
        //     ogImage:ogImage, 
        //     ogImageWidth:ogImageWidth, 
        //     ogImageHeight:ogImageHeight, 
        //     ogDesc:ogDesc
        // })
        
        
        //add page title
        if (metaTags.title != null) {
            document.title = metaTags.title
        } else {
            document.title = 'Univer'
        }                    

        //add meta tags
        if (metaTags.desc != null) {            
            let metaDesc = document.createElement('meta')
            metaDesc.name = "description"
            metaDesc.content = metaTags.desc 
            document.getElementsByTagName('head')[0].appendChild(metaDesc);
        } else {
            let metaDesc = document.createElement('meta')
            metaDesc.name = "description"
            metaDesc.content = this.lang('meta_description_homepage') 
            document.getElementsByTagName('head')[0].appendChild(metaDesc);
        }       

        //meta keywords
        if (metaTags.keywords != null) {
            let metaKeywords = document.createElement('meta')
            metaKeywords.name = "keywords"
            metaKeywords.content = metaTags.keywords
            document.getElementsByTagName('head')[0].appendChild(metaKeywords);
        }       
        
        //og:type 
        if (metaTags.ogType != null) {
            let metaOgType = document.createElement('meta')
            metaOgType.setAttribute('property', 'og:type') 
            metaOgType.content = metaTags.ogType
            document.getElementsByTagName('head')[0].appendChild(metaOgType);
        }        

        //og:title
        if (metaTags.ogTitle != null) {
            let metaOgTitle = document.createElement('meta')
            metaOgTitle.setAttribute('property', 'og:title')
            metaOgTitle.content = metaTags.ogTitle
            document.getElementsByTagName('head')[0].appendChild(metaOgTitle);
        } else {
            let metaOgTitle = document.createElement('meta')
            metaOgTitle.setAttribute('property', 'og:title')
            metaOgTitle.content = 'Univer'
            document.getElementsByTagName('head')[0].appendChild(metaOgTitle);
        }            

        //og:url - FIX
        let metaOgUrl = document.createElement('meta')
        metaOgUrl.setAttribute('property', 'og:url')
        metaOgUrl.content = process.env.VUE_APP_DOMAIN + window.location.pathname
        document.getElementsByTagName('head')[0].appendChild(metaOgUrl);

        //og:image

        if (metaTags.ogImage != null) {
            let metaOgImage = document.createElement('meta')
            metaOgImage.setAttribute('property', 'og:image')
            metaOgImage.content = metaTags.ogImage
            document.getElementsByTagName('head')[0].appendChild(metaOgImage);
    

            //og:image:width
            if ( metaTags.ogImageWidth != null) {
                let metaOgImageWidth = document.createElement('meta')
                metaOgImageWidth.setAttribute('property', 'og:image:width')
                metaOgImageWidth.content = metaTags.ogImageWidth
                document.getElementsByTagName('head')[0].appendChild(metaOgImageWidth);
            }           
    
            //og:image:height
            if (metaTags.ogImageHeight != null) {
                let metaOgImageHeight = document.createElement('meta')
                metaOgImageHeight.setAttribute('property', 'og:image:height')
                metaOgImageHeight.content = metaTags.ogImageHeight
                document.getElementsByTagName('head')[0].appendChild(metaOgImageHeight);
            }
            
        } else {
            let metaOgImage = document.createElement('meta')
            metaOgImage.setAttribute('property', 'og:image')
            metaOgImage.content = process.env.VUE_APP_DOMAIN + '/images/univer-logo_600x315.png'
            document.getElementsByTagName('head')[0].appendChild(metaOgImage);
    
            //og:image:width
            let metaOgImageWidth = document.createElement('meta')
            metaOgImageWidth.setAttribute('property', 'og:image:width')
            metaOgImageWidth.content = '600'
            document.getElementsByTagName('head')[0].appendChild(metaOgImageWidth);
    
            //og:image:height
            let metaOgImageHeight = document.createElement('meta')
            metaOgImageHeight.setAttribute('property', 'og:image:height')
            metaOgImageHeight.content = '315'
            document.getElementsByTagName('head')[0].appendChild(metaOgImageHeight);
        }
        
        //og:description
        if (metaTags.ogDesc != null) {
            let metaOgDesc = document.createElement('meta')
            metaOgDesc.setAttribute('property', 'og:description')
            metaOgDesc.content = metaTags.ogDesc
            document.getElementsByTagName('head')[0].appendChild(metaOgDesc);
        } else {
            let metaOgDesc = document.createElement('meta')
            metaOgDesc.setAttribute('property', 'og:description')
            metaOgDesc.content = this.lang('meta_description_homepage')
            document.getElementsByTagName('head')[0].appendChild(metaOgDesc);
        }
        
    
    },
    GTtrack ( category, action, label){
        // console.log("track " , category, action, label);
        try {
            window.dataLayer.push({
                'event': 'event_activation',
                'dl_category': category,
                'dl_action': action,
                'dl_label': label
            });
        } catch (e) {
            console.log("not found dataLayer")
        }     
    },
    setDataLayer(category, action, label){
        let acceptCookiePolicy = this.$cookies.get('cookiePolicyU');          
        if (acceptCookiePolicy == 1){            
            this.GTtrack( category, action, label);                
        } 
    }        
  }
});

//custom directive
Vue.directive('click-outside',{
  bind: function (el, binding, vnode) {   
      el.eventOnClick = function (event) {                  
          if (!(el == event.target || el.contains(event.target)) ) {
              // call method provided in attribute value
              vnode.context[binding.expression](event);
          }
      };      
      document.addEventListener('click', el.eventOnClick);      
  }, unbind: function (el) {      
      document.removeEventListener('click', el.eventOnClick);      
  },
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

